var _rect, _rect2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewBadge = function SvgNewBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.47,
    width: 59.5,
    height: 25.5,
    rx: 3.25,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.47,
    width: 59.5,
    height: 25.5,
    rx: 3.25,
    stroke: "#FF7800",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 14.22,
    r: 3,
    fill: "#FF7800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.368 13.84 2.085-4.114h2.283l-3.315 6.104v3.89h-2.106v-3.821L20 9.726h2.297l2.071 4.115Zm11.382 5.88h-5.756V9.726h5.756v1.736h-3.637v2.194h3.384v1.737h-3.384v2.577h3.637v1.75Zm10.958 0h-2.693l-4.348-7.56h-.062c.019.314.035.63.048.95a3061.877 3061.877 0 0 1 .082 1.907v4.703h-1.893V9.726h2.673l4.34 7.485h.048c-.009-.31-.02-.617-.034-.923l-.04-.916c-.01-.305-.02-.61-.028-.916v-4.73h1.907v9.994Zm2.523 0V9.726h2.119v9.994h-2.12Zm1.066-12.988c.31 0 .576.072.8.218.223.142.335.408.335.8 0 .387-.112.656-.335.807a1.43 1.43 0 0 1-.8.218c-.315 0-.583-.072-.807-.218-.218-.15-.328-.42-.328-.807 0-.392.11-.658.328-.8.224-.146.492-.218.807-.218Z",
    fill: "#FF7800"
  })));
};
export default SvgNewBadge;